import { getShellBridge } from './shellBridge';

/**
 * Tells mobile-shell this page has painted real content, so it can drop its own loading UI over
 * the page's — see `NativeLanding` and `Lobby`, which call this on `/` once each has something worth
 * showing, and `useShellUiReady`, which covers every other route. A no-op in a plain browser (no shell); on a
 * refused origin the bridge warns and drops it. Safe to call more than once, since the shell's own handler is idempotent.
 */
export function postUiReady(): void {
  getShellBridge()?.send('ui.ready', {});
}
